export function createFeatureAppId(faConfig) {
    return ((faConfig === null || faConfig === void 0 ? void 0 : faConfig.name) || 'unknown-fa') + '_in_content_layer';
}
//# sourceMappingURL=create-feature-app-id.js.map